import * as React from 'react';

import {useGetLimitsByType} from '../../limits';
import {OpenableModals, useOpenableModal} from '../../openable-modals';

import {CreatePipelineModal} from './create-pipeline-modal';

export function CreatePipelineModalWrapper() {
    const {onClose} = useOpenableModal(OpenableModals.CREATE_PIPELINE_MODAL);
    const {onOpen: openFeatureGateModal} = useOpenableModal(
        OpenableModals.PIPELINES_FEATURE_GATE_MODAL
    );
    const {limits} = useGetLimitsByType('PIPELINES');

    if (!limits || !limits.canAdd) {
        openFeatureGateModal();
        onClose();

        return null;
    }

    return <CreatePipelineModal isOpen={true} onClose={onClose} />;
}
